if (!customElements.get('filter-exposure')) {
  customElements.define(
    'filter-exposure',
    class FilterExposure extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.originalFilterItems = document.querySelectorAll(
          '[data-collection-exposed-filters-external-el="drawerItem"]',
        )

        this.initialize()
      }

      initialize () {
        this.newFilterItems = document.querySelectorAll(
          '[data-collection-exposed-filters-external-el="drawerTrigger"]',
        )

        if (this.newFilterItems.length > 0) {
          this.newFilterItems.forEach(trigger => {
            this.listeners.add(
              trigger,
              'click',
              this.handleTriggerClick.bind(this),
            )
          })
        }
      }

      handleTriggerClick (e) {
        this.originalFilterItems.forEach(item => {
          if (item.dataset.filterKey === e.target.dataset.filterKey) {
            item.querySelector('details').setAttribute('open', true)
          } else {
            item.querySelector('details').removeAttribute('open')
          }
        })
      }
    },
  )
}
